/**
 * AI Scribe V2 — CLINICAL EVENTS column
 *
 * Structured findings the scribe extracts while the visit is running.
 *
 * @author [Rajkumar Rathod]
 */

import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import Flex from "../../../../../../../../../../components/Flex";
import Text from "../../../../../../../../../../components/Text";
import {
  PRIMITIVE,
  px,
} from "../../../../../../../../../../tokens/design-tokens";
import { SCRIBE_V2_COLORS } from "../constants";
import { ClinicalEvent } from "../types";
import ClinicalEventCard from "./ClinicalEventCard";
import ScribePanelHeader from "./ScribePanelHeader";

interface ClinicalEventsPanelProps {
  events: ClinicalEvent[];
}

const ClinicalEventsPanel = ({ events }: ClinicalEventsPanelProps) => (
  <Flex
    flexDirection="column"
    height="100%"
    sx={{
      minWidth: 0,
      flex: 1,
      borderLeft: `1px solid ${SCRIBE_V2_COLORS.panelDivider}`,
    }}
  >
    <ScribePanelHeader
      icon={<MonitorHeartOutlinedIcon />}
      label="Clinical Events"
    />

    <Flex
      flexDirection="column"
      gap={1}
      p={px(PRIMITIVE.spacing[12])}
      sx={{ flex: 1, overflowY: "auto" }}
    >
      {events.length === 0 ? (
        <Flex
          flex={1}
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          px={1}
        >
          <Text
            sx={{
              color: SCRIBE_V2_COLORS.textSecondary,
              fontSize: px(PRIMITIVE.typography.fontSize.body.b5),
            }}
          >
            Symptoms, medications and risk findings will surface here as they
            are mentioned.
          </Text>
        </Flex>
      ) : (
        events.map((event) => (
          <ClinicalEventCard key={event.id} event={event} />
        ))
      )}
    </Flex>
  </Flex>
);

export default ClinicalEventsPanel;
